import React, { useMemo, useState, useCallback, useEffect } from "react";
import xss from "xss";
import Select from "react-select";

import { kundenActions } from "../../actions";
import { useDispatch, useStore } from "react-redux";
import { Tooltip } from "../../utils/components/Tooltip";
import "./SelectKonto.css";

const SelectKonto = (props) => {
  const { ...attribute } = props || {};
  const { kundenStorage } = useStore().getState();
  const kunde = kundenStorage.getKunde();
  const dispatch = useDispatch();

  // Local state to keep track of whether the user has interacted with the select.
  // While touched is false, the placeholder option ("--Bitte auswählen--") will be shown.
  const [touched, setTouched] = useState(false);

  useEffect(() => {
    dispatch(kundenActions.setKontoSelected(false));
  }, [dispatch]);

  const setIban = useCallback(
    (item, type) => {
      if (type && type.action === "select-option") {
        setTouched(true);
        const value = xss(item.value);
        if (value !== null && value !== "") {
          dispatch(kundenActions.setKontoSelected(true));
          kunde.kundenkonto = value;
          dispatch(kundenActions.setKunde(kunde));
        }
      }
    },
    [dispatch, kunde]
  );

  const selectOptions = useMemo(() => {
    const kontoOptions = (kunde.konten || []).map((konto) => ({
      value: konto.iban,
      label: (
        <div className="selectOption">
          <div>{konto.iban}</div>
          {konto.kontoArt ? <div className="fs-6">Art: {konto.kontoArt}</div> : null}
          {konto.abweichenderInhaber ? <div className="fs-6">Inhaber: {konto.abweichenderInhaber}</div> : null}
        </div>
      )
    }));

    // Placeholder option like other dropdowns (e.g. "Gebietsansässiger")
    return [{ value: "", label: "--Bitte auswählen--" }, ...kontoOptions];
  }, [kunde]);

  // When not touched, force the placeholder option to be displayed.
  // After the user interacts (touched === true) show the selected value from store (if any).
  const defaultValue = kunde.kundenkonto || "";
  const selectedOption = selectOptions.find((item) => item.value === defaultValue) || selectOptions[0];
  const value = !touched ? selectOptions[0] : selectedOption;

  return (
    <div className="row mt-one-half mb-one-half align-items-center">
      <div className="col-9 col-md-7">
        <Select
          className="r-select form-select"
          onChange={setIban}
          classNamePrefix="r-select"
          value={value}
          options={selectOptions}
          {...attribute}
        />
      </div>
      <Tooltip className="col-1">
        Wählen Sie ein zahlungsverkehrsfähiges Konto, über das die Transaktion abgewickelt werden soll. Bitte achten Sie
        bei Bestellungen auf ausreichend Deckung.
      </Tooltip>
    </div>
  );
};

export default SelectKonto;
